import client from '@lib/http/client'

interface ChangePlanRequest {
  recordKey: string
  paymentPeriod: number
}

export const changePlan = ({ recordKey, paymentPeriod }: ChangePlanRequest) =>
  client.post('payments/change-package-on-account', {
    recordKey,
    paymentPeriod
  })
